import { store } from "@/store/store";
import { endpoints } from "@/config/endpoints";
import { APP_DEMO } from "@/config/demo";
import { AccountType } from "@/enums/account-type";

const exceptionEndpoints = [
  endpoints.users.login,
  endpoints.users.logout,
  endpoints.gmbInsights,
  endpoints.gmbInsightsOld,
  endpoints.gmbPostsInsights,
  endpoints.reviews,
  endpoints.reviewsSearch,
  endpoints.periodicRankings,
  endpoints.periodicRankingsTable,
  endpoints.periodicRankingsTableSummary,
  endpoints.reviewBooster.reviews,
  endpoints.facilities,
  endpoints.keywordImpressions.list,
  endpoints.keywordImpressions.summary,
  endpoints.keywordImpressions.topKeywords,
  endpoints.keywordImpressions.keywords,
  endpoints.keywordImpressions.byDate,
  endpoints.keywordImpressions.dates,
  endpoints.gmbServicesList,
  endpoints.gmbAttributes,
  endpoints.reviewsStatsTable,
  endpoints.reviewsStats,
  endpoints.gmbCustomerMediaByReviews
]; // endpoints which "works" like get, so shouldn't be blocked

const blockedMethods = ["post", "put", "patch", "delete"];

export const shouldBlockRequest = config => {
  const isDemoMode = store.getters["auth/isDemoMode"];
  const isBlockedMethod = blockedMethods.includes(config.method);
  const isExceptEndpoint = exceptionEndpoints.includes(config.url);
  const isAdminMode = store.state.company.company
    ? store.getters["company/accountType"] === AccountType.ADMIN
    : false;
  return isDemoMode && isBlockedMethod && !isExceptEndpoint && !isAdminMode;
};

export const isDemoError = error => {
  return error && error.message === APP_DEMO.REQUEST_CANCEL_MSG;
};
